var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33366 10.5L10.0003 10.5L16.667 10.5C16.667 6.81811 13.6822 3.83334 10.0003 3.83334C6.31843 3.83334 3.33366 6.81811 3.33366 10.5ZM18.3337 10.5C18.3337 15.1024 14.6027 18.8333 10.0003 18.8333C5.39795 18.8333 1.66699 15.1024 1.66699 10.5C1.66699 5.89763 5.39795 2.16667 10.0003 2.16667C14.6027 2.16667 18.3337 5.89763 18.3337 10.5Z",
    fill: "#3532F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.66699,
    y: 7.16667,
    width: 6.66667,
    height: 1.66667,
    fill: "#3532F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon-3.e9ea4b66bd28cc35492b74b2ea578a4f.svg";
export { ForwardRef as ReactComponent };